module.exports = __webpack_public_path__ + "img/food_pin_selected.cf354826.png";